<template>
  <van-pull-refresh
    v-bind="$attrs"
    v-on="$listeners"
    v-model="isLoading"
  >
  <p slot="pulling">
    <cc-svg-icon size=".17rem" class-name="refresh-icon" icon-class="refresh"></cc-svg-icon>
    下拉刷新
  </p>
    <p slot="loosing">
      <cc-svg-icon size=".17rem" class-name="refresh" icon-class="release-refresh"></cc-svg-icon>释放刷新
  </p>
  <slot></slot>
  </van-pull-refresh>
</template>

<script>
import Vue from 'vue'
import { PullRefresh } from 'vant'
Vue.use(PullRefresh)
export default {
  name: 'cc-pull-refresh',
  components: {},
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      isLoading: false
    }
  },

  computed: {},

  watch: {
    value: {
      immediate: true,
      handler (newVal) {
        this.isLoading = newVal
      }
    }

  },

  created () {},

  methods: {}
}

</script>
